import React from 'react';
import { Wrench, Shield, Phone } from 'lucide-react';

const EquipmentsPage = () => {
  return (
    <div className="min-h-screen bg-black">
      {/* Hero */}
      <div className="relative h-96 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1520962922320-2038909c6ecb?w=1920&q=80"
          alt="Equipments"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/56 to-transparent"></div>
        <div className="absolute inset-0 flex items-center px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto w-full">
            <h1 className="text-6xl md:text-8xl font-black text-white uppercase tracking-tight mb-4">
              Know The <span className="text-yellow-400">Equipments</span>
            </h1>
            <p className="text-xl text-gray-300">Premium Certified Safety Gear</p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="py-20 bg-gradient-to-b from-black to-gray-950">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            {/* Equipment Items */}
            <section className="bg-white/5 border border-white/10 rounded-xl p-8">
              <div className="flex items-start space-x-4 mb-6">
                <Wrench className="text-yellow-400 flex-shrink-0 mt-1" size={40} />
                <h2 className="text-3xl font-bold text-white">Static Rope</h2>
              </div>
              <p className="text-gray-300 leading-relaxed">
                We use slings, kern mantle and braided ropes. The size of a double braided rope is 10mm. The breaking strength of this rope is <strong className="text-white">25 KN (Kilo Newton)</strong>. This rope is made up of nylon and polyester.
              </p>
            </section>

            <section className="bg-white/5 border border-white/10 rounded-xl p-8">
              <div className="flex items-start space-x-4 mb-6">
                <Shield className="text-yellow-400 flex-shrink-0 mt-1" size={40} />
                <h2 className="text-3xl font-bold text-white">Full Body Harness</h2>
              </div>
              <p className="text-gray-300 leading-relaxed">
                We use high quality fully padded body harness with a D-ring and locking system. These harnesses are tested at extreme conditions. The sizes available in these harnesses are <strong className="text-white">XS, S, M, and XL</strong>. These harnesses are fully adjustable according to size and shape of the body.
              </p>
            </section>

            <section className="bg-white/5 border border-white/10 rounded-xl p-8">
              <div className="flex items-start space-x-4 mb-6">
                <Shield className="text-yellow-400 flex-shrink-0 mt-1" size={40} />
                <h2 className="text-3xl font-bold text-white">Ankle Harness</h2>
              </div>
              <p className="text-gray-300 leading-relaxed">
                This harness is designed and engineered specially for bungy jumping and they meet all the standards under <strong className="text-white">SANZ (Standard of Australia and New Zealand)</strong> regulations. This ankle harness is double padded with two buckles on each ankle and constructed with 100 mm specs webbing.
              </p>
            </section>

            <section className="bg-gradient-to-br from-yellow-400/10 to-yellow-900/10 border border-yellow-400/20 rounded-xl p-8">
              <div className="flex items-start space-x-4 mb-6">
                <Shield className="text-yellow-400 flex-shrink-0 mt-1" size={40} />
                <h2 className="text-3xl font-bold text-white">Bungy Rubber Cord</h2>
              </div>
              <div className="space-y-4 text-gray-300 leading-relaxed">
                <p>
                  These cords are specially designed to operate bungy jumping. After the jump these latex rubber cord gives <strong className="text-white">350% to 400% elongation</strong> and provide a smooth flight. These cords meet all the desired specification required by SANZ (Standard of Australia and New Zealand).
                </p>
                <p>
                  We use high quality of latex imported from <strong className="text-white">Malaysia and Thailand</strong>. Our jump masters then weave these latex strands as per the weight requirement. Our rubber has a silicon coating, which minimise the friction between the individual strands.
                </p>
                <p>
                  We use special compounds and covering to protect the rope from UV rays, sunlight and dust. During the manufacturing of rope, 2 Teflon bobbins are wrapped up to both of its ends.
                </p>
                <p>
                  Even our ropes have a <strong className="text-white">double safety system</strong>. We infuse an extra safety line with bungy cord during the process of its manufacturing.
                </p>
              </div>
            </section>

            <section className="bg-white/5 border border-white/10 rounded-xl p-8">
              <div className="flex items-start space-x-4 mb-6">
                <Wrench className="text-yellow-400 flex-shrink-0 mt-1" size={40} />
                <h2 className="text-3xl font-bold text-white">Carabiners</h2>
              </div>
              <p className="text-gray-300 leading-relaxed">
                We use high quality, good branded carabiners. They are having double-lock system that minimize chances of failure. The capacity of carabiners are <strong className="text-white">25 KN and 40 KN</strong>, which is strong enough for bungy jumping.
              </p>
            </section>

            <section className="bg-white/5 border border-white/10 rounded-xl p-8">
              <div className="flex items-start space-x-4 mb-6">
                <Wrench className="text-yellow-400 flex-shrink-0 mt-1" size={40} />
                <h2 className="text-3xl font-bold text-white">Walkie-Talkie</h2>
              </div>
              <p className="text-gray-300 leading-relaxed">
                This is a very important equipment to conduct bungy jumping. We use high quality of modern equipment for conducting jumping. Walkie-Talkie helps in communication between ground staffs, jumpmasters and jumpers. It avoids further mis-communication and any chances of errors.
              </p>
            </section>

            <section className="bg-white/5 border border-white/10 rounded-xl p-8">
              <div className="flex items-start space-x-4 mb-6">
                <Shield className="text-yellow-400 flex-shrink-0 mt-1" size={40} />
                <h2 className="text-3xl font-bold text-white">2mtr Safety Line</h2>
              </div>
              <p className="text-gray-300 leading-relaxed">
                We use a 2mtr safety line to connect the full body harness to the jumpers with the bungy rubber cord as a <strong className="text-white">double safety</strong>. In case of any failures with ankle harness, the safety line keeps the jumpers attached to the bungy cord, hence protects jumpers from accidents.
              </p>
            </section>

            {/* Summary */}
            <section className="bg-gradient-to-br from-green-500/10 to-green-900/10 border border-green-500/20 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-white mb-4">Premium Quality Assurance</h3>
              <p className="text-gray-300 leading-relaxed">
                All our equipment is internationally certified, regularly inspected, and maintained to the highest standards. We import premium materials and follow SANZ guidelines to ensure every component meets world-class safety requirements.
              </p>
            </section>

            {/* CTA */}
            <section className="text-center">
              <a
                href="tel:8506865393"
                className="inline-flex items-center space-x-3 bg-yellow-400 hover:bg-yellow-300 text-black px-8 py-4 rounded-full font-bold text-lg transform hover:scale-105 transition-all duration-300 shadow-lg shadow-yellow-400/50"
              >
                <Phone size={24} />
                <span>Call Us: 8506865393</span>
              </a>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquipmentsPage;